import { TeamAccessDTO } from '../team/team-access.dto';
import { WikiPostListDTO } from '../wiki-post/wiki-post-list.dto';

export class WikiCategoryDTO extends TeamAccessDTO {

    name: string;

    description: string;

    parent: {
        
        id: string;

        name: string;

    };

    sortOrder: number;

    posts: Array<WikiPostListDTO>;

}
